import { Form } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { DigitalFormsQueries } from '@frontend/api-digital-forms';
import { useOrgData } from '@frontend/get-org-data';

const DEFAULT_PAGE_LIMIT = 100;

export type FormWithDocumentType = Form & { documentType: string };

export const useFormListV3 = (businessGroupIds: string[]) => {
  const { orgId } = useOrgData();

  const { data, ...rest } = DigitalFormsQueries.useFormListV3(
    {
      orgRequest: { orgId, businessGroupIds },
      pageRequest: { pageLimit: DEFAULT_PAGE_LIMIT, pageNumber: 1 },
    },
    {
      enabled: !!businessGroupIds.length,
    }
  );

  const formattedData: FormWithDocumentType[] =
    data?.pages
      ?.flatMap((page) => page.rows)
      .map((form) => ({ ...form, documentType: 'form' }))
      .filter((form) => !!form) ?? [];

  return {
    ...rest,
    data,
    formattedData,
  };
};

export const usePacketListV3 = (businessGroupIds: string[]) => {
  const { orgId } = useOrgData();

  const { data, ...rest } = DigitalFormsQueries.usePacketListV3(
    {
      orgRequest: { orgId, businessGroupIds },
      pageRequest: { pageLimit: DEFAULT_PAGE_LIMIT, pageNumber: 1 },
    },
    {
      enabled: !!businessGroupIds.length,
    }
  );

  const formattedData: FormWithDocumentType[] =
    data?.pages
      ?.flatMap((page) => page.rows)
      .map((packet) => ({ ...packet, documentType: 'packet' }))
      .filter((packet) => !!packet) ?? [];

  return {
    ...rest,
    data,
    formattedData,
  };
};

export const useCombinedDocumentsListV3 = (businessGroupIds: string[]) => {
  const { formattedData: forms } = useFormListV3(businessGroupIds);
  const { formattedData: packets } = usePacketListV3(businessGroupIds);
  return [...forms, ...packets];
};
